export class RecruitedCandidateDTO {
  constructor({ candidateId, demandId, recruited } = {}) {
    this.candidateId = candidateId;
    this.demandId = demandId;
    this.recruited = recruited;
  }

  prepareRecruitedCandidateData() {
    return {
      candidateId: this.candidateId,
      demandId: this.demandId,
      recruited: this.recruited,
    };
  }
}
